import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  categories: [],
  category: null,
  items: [],
  comandas: [],
  comanda: null,
  server: null,
};

export default function data(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@data/DECODED_SUCCESS': {
        const { server } = action.payload;
        draft.server = { ...server };
        localStorage.setItem('server', JSON.stringify(server));
        break;
      }

      case '@data/COMANDAS_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@data/COMANDAS_FAILURE': {
        draft.loading = false;
        break;
      }

      case '@data/COMANDAS_SUCCESS': {
        const { comandas } = action.payload;
        draft.comandas = [...comandas];
        draft.loading = false;
        break;
      }

      case '@data/COMANDA_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@data/COMANDA_ITEMS_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@data/COMANDA_ORDERS_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@data/COMANDA_AUDITS_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@data/COMANDA_FAILURE': {
        draft.loading = false;
        break;
      }

      case '@data/COMANDA_SUCCESS': {
        const { comanda } = action.payload;
        draft.comanda = { ...comanda };
        draft.loading = false;
        break;
      }

      case '@data/CATEGORIES_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@data/CATEGORIES_FAILURE': {
        draft.loading = false;
        break;
      }

      case '@data/CATEGORIES_SUCCESS': {
        const { categories } = action.payload;
        draft.categories = [...categories];
        draft.loading = false;
        break;
      }

      case '@data/ITEMS_REQUEST': {
        const { category = null } = action.payload;
        if (category) {
          draft.category = { ...category };
          draft.loading = true;
        }
        break;
      }

      case '@data/ITEMS_FAILURE': {
        draft.loading = false;
        break;
      }

      case '@data/ITEMS_SUCCESS': {
        const { items } = action.payload;
        draft.items = [...items];
        draft.loading = false;
        break;
      }

      case '@data/CLOSE_COMANDA_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@data/CLOSE_COMANDA_FAILURE': {
        draft.loading = false;
        break;
      }

      case '@data/CLOSE_COMANDA_SUCCESS': {
        const {
          parameters: { prevenda_id: comanda_id },
        } = action.payload;

        draft.comandas = [
          ...draft.comandas.map(comanda => {
            return {
              ...comanda,
              situacao:
                comanda.comanda_id === comanda_id ? 'F' : comanda.situacao,
            };
          }),
        ];
        draft.loading = false;
        break;
      }

      case '@data/REOPEN_COMANDA_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@data/REOPEN_COMANDA_FAILURE': {
        draft.loading = false;
        break;
      }

      case '@data/REOPEN_COMANDA_SUCCESS': {
        const {
          parameters: { prevenda_id: comanda_id },
        } = action.payload;

        draft.comandas = [
          ...draft.comandas.map(comanda => {
            return {
              ...comanda,
              situacao:
                comanda.comanda_id === comanda_id ? 'A' : comanda.situacao,
            };
          }),
        ];
        draft.loading = false;
        break;
      }

      case '@starting': {
        draft.loading = false;
        break;
      }

      default:
    }
  });
}
